import { LuSearch } from "@/Components/Icons/Icons";
export default {

  row1: [
    {
      column: "column1",
      columnWidth: "100%",
      rows: {
        row1: [
          {
            name: "exportProductDrawbackDesc",
            component: "typographytext",
            actionText: "DBK Sr.No:",
             width: "10%"
          },
          {
            name: "exportProductDrawbackDbkSrNo",
            component: "text-field",
            gap: false,
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getDrawer",
             width: "40%",
            autofillTargets: {
              "exportProductDrawbackDBKRate": "rate",
              "exportProductDrawbackDBKCap": "dbkcap",
              "exportProductDrawbackQuantityValue": "dbkunit",
              "exportProductDrawbackDBKDesc": "description",
            },
          },
          {
            name: "exportProductDrawbackDBKDesc",
            component: "typographytext",
            actionText: "Select SNo with Suffix A- if CENVAT not availed,B -if CENVAT availed",
            width: "50%",
          }
        ],
      },
    },
  ],
  row2: [
    {
      column: "column2",
      highlight: true,
      columnWidth: "34%",
      rows: {
        row1: [
          {
            name: "exportProductDrawbackFOBValue",
            label: "FOB Value",
            component: "text-field",
            dataType: "int",
            width: "100%",
            disabled: true
          },

          {
            name: "exportProductDrawbackQuantity",
            label: "Quantity",
            component: "text-field",
            dataType: "int",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "DBKCAP",
            actionText: "DBK Under",
            component: "typographytext",
          },
        ],
        row3: [
          {
            name: "exportProductDrawbackDbkUnder",
            label: "Invoice Type",
            component: "radiobutton",
            defaultValue: "actual",  // ✅ lowercase for consistency with options
            options: [
              { label: "Actual", value: "actual" },
              { label: "Provisional", value: "provisional" },
            ],
          },          
        ],
      },
    },
    {
      column: "column3",
      highlight: true,
      columnWidth: "62%",
      rows: {
        row1: [
          {
            name: "exportProductDrawbackDBKDesc",
            actionText: "DBK Desc",
            component: "textarea",
            width: "100%",
            height: "60px",
            sx: {
              borderRadius: "12px",
            },
            disabled: true
          },
        ],
        row2: [
          {
            name: "exportProductDrawbackDBKRate",
            label: "DBK Rate",
            component: "text-field",
            dataType: "int",
            width: "16%",
          },
          {
            name: "DBKRate",
            actionText: "%",
            sx: {
              mt: 4,
            },
            component: "typographytext",
            width: "2%",
          },
          {
            name: "exportProductDrawbackDBKCap",
            component: "text-field",
            label: "DBKCAP",
            dataType: "int",
            width: "20%",
          },
          {
            name: "DBKCAP",
            actionText: "/",
            sx: {
              mt: 4,
            },
            component: "typographytext",
            width: "2%",
          },
          {
            name: "exportProductDrawbackQuantityValue",
            component: "text-field",
            width: "30%",
            disabled: true,
          },
        ],
        row3: [
          {
            name: "exportProductDrawbackDKAmt",
            label: "DBKAmt",
            component: "text-field",
            dataType: "int",
            width: "30%",
            disabled: true,
            mt: 5,

          },
          {
            name: "DBKAmount",
            actionText: "@",
            component: "typographytext",
            width: "5%",
          },

          {
            name: "exportProductDrawbackDKAmtDesc",
            component: "textarea",
            width: "100%",
            disabled: true,
            sx: {
              borderRadius: "12px",
              marginTop: "10px",
            },
          },
        ],
      },
    },
  ]
};
